var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttributes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 85,
    viewBox: "0 0 97 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6217 2.00046C18.3076 2.00046 12.0097 4.44699 7.20425 9.33985C-2.40696 19.1267 -2.39588 34.9135 7.20425 44.7079L45.6908 83.9921V83.9929C46.1475 84.4547 46.7706 84.7145 47.4208 84.7145C48.0711 84.7145 48.6942 84.4547 49.1509 83.9929C61.9938 70.9157 74.8332 57.8238 87.6744 44.7457C97.2856 34.9589 97.2856 19.1655 87.6744 9.37764C78.0632 -0.409158 62.4115 -0.409158 52.7996 9.37764L47.4371 14.8538L42.0746 9.3394C37.2691 4.44632 30.9329 2 24.619 2L24.6217 2.00046ZM24.6217 6.79248C29.6564 6.79248 34.6877 8.8018 38.5792 12.7637L45.7284 20.0276V20.0268C46.186 20.4886 46.8091 20.7492 47.4593 20.7492C48.1095 20.7492 48.7326 20.4886 49.1893 20.0268L56.3014 12.8011C64.0824 4.87752 76.4346 4.87839 84.2156 12.8011C91.9966 20.7237 91.9966 33.4384 84.2156 41.3628C71.9501 53.8517 59.7046 66.3345 47.4393 78.8237L10.6652 41.3259C2.89026 33.393 2.88417 20.6885 10.6652 12.7641C14.5555 8.80245 19.587 6.79293 24.6227 6.79293L24.6217 6.79248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1436 47.43L32.2409 30.3326L49.3383 47.43L93.7914 2.97681",
    stroke: "white",
    strokeWidth: 4.88496,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributes);
export default __webpack_public_path__ + "static/media/attributes.0b0dc4761d1607ddbd73c5bc9fff1f17.svg";
export { ForwardRef as ReactComponent };